<template>
  <header>
    <div class="title">
      <span>皆で「密」を避けて地域を守ろう</span>
      <div>
        <h1>お買物混雑マップ</h1>
        <span>Powered by Beacon Bank</span>
      </div>
    </div>
    <a class="balloon" href="#" @click.prevent="scrollToNews">
      <span v-if="isPC">鎌倉観光混雑マップが登場！</span>
      <span v-else>鎌倉観光版<br />が登場！</span>
    </a>
    <a class="corp-link" href="https://www.unerry.co.jp/" target="_blank"></a>
  </header>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { mapGetters, mapState } from 'vuex';

export default defineComponent({
  name: 'Header',
  computed: {
    ...mapGetters(['isPC', 'isSP']),
    ...mapState(['selectedPlace'])
  },
  methods: {
    scrollToNews() {
      // モバイルの場合詳細表示だとNews隠しているのでホームに戻す
      if (this.isSP && this.selectedPlace) {
        this.$router.replace({ name: 'Home' }).catch(() => {});
      }

      let el = document.getElementById('news-kamakura');
      if (el) {
        this.$smoothScroll({
          scrollTo: el,
          duration: 300,
          updateHistory: false
        });
      }
    }
  }
});
</script>

<style scoped lang="scss">
header {
  display: flex;
  height: 74px;
  border-bottom: 1px solid #eeeeee;
  align-items: center;

  .title {
    margin-left: 20px;
    margin-top: -3px;

    > span {
      color: #666666;
      font-size: 11px;
      font-weight: bold;
      line-height: 11px;
      margin-left: 1px;
    }

    > div {
      display: flex;
      align-items: baseline;
      margin-top: 5px;

      h1 {
        margin: 0;
        font-size: 22px;
        line-height: 22px;
      }

      span {
        margin-left: 6px;
        font-size: 12px;
        line-height: 12px;
        font-weight: bold;
        color: #000;
      }
    }
  }

  .balloon {
    margin-top: 5px;
    margin-left: 25px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 180px;
    height: 34px;
    background-color: #9db423;
    color: #fff;
    font-size: 13px;
    letter-spacing: -0.65px;
    padding-left: 2px;
    font-weight: bold;
    line-height: 13px;
    border-radius: 4px;
    box-shadow: 2px 2px 0px #00000029;
    text-align: center;
    text-decoration: none;

    &:before {
      content: '';
      position: absolute;
      top: 50%;
      left: -16px;
      margin-top: -4px;
      border: 4px solid transparent;
      border-left: 8px solid transparent;
      border-right: 8px solid #9db423;
    }
  }

  .corp-link {
    margin-left: auto;
    margin-right: 19px;
    margin-top: 3px;
    width: 124px;
    height: 33px;
    background-size: cover;
    background-image: url('@/assets/images/unerry.svg');
  }
}

@media screen and (max-width: 767px) {
  header {
    height: 49px;

    .title {
      margin-left: 11px;
      margin-top: -5px;

      > span {
        font-size: 10px;
        line-height: 10px;
        margin-left: 1px;
      }

      > div {
        margin-top: 2px;

        h1 {
          margin: 0;
          font-size: 18px;
          line-height: 18px;
        }

        span {
          display: none;
        }
      }
    }

    .balloon {
      margin-top: 1px;
      margin-left: 10px;
      width: 60px;
      height: 34px;
      font-size: 9px;
      line-height: 11px;
      letter-spacing: -0.27px;
      text-align: center;
    }

    .corp-link {
      margin-right: 14px;
      margin-top: 3px;
      width: 31px;
      height: 36px;
      background-image: url('@/assets/images/unerry2.svg');
    }
  }
}
</style>
